import { Tooltip } from '@dbt-labs/sourdough';

type CustomCellProps = {
  children: React.ReactNode;
  tooltip: string;
  align?: 'left' | 'right';
  /** If disable is true, the entire column will just be gray. */
  disable?: boolean;
  displayDisabledChildren?: boolean;
};

/**
 * You should favor using CustomCell or LinkCell if you need to override Cell to ensure
 * hovering over the cell will reveal tooltip content
 */
export const CustomCell = ({
  children,
  tooltip,
  disable,
  displayDisabledChildren = false,
}: CustomCellProps) => {
  if (disable) {
    return (
      <div className="relative h-full w-full">
        <div className="absolute -inset-4 flex items-center justify-center bg-bgDisabled">
          {displayDisabledChildren && children}
        </div>
      </div>
    );
  }
  return (
    <Tooltip displayOnlyWhenTruncated content={tooltip} className="w-full">
      {(ref) => (
        <div ref={ref} className="w-full truncate">
          {children}
        </div>
      )}
    </Tooltip>
  );
};
